// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-2Q-GD","title":"title-PnxAD","message":"message-GgDn6","button_wrapper":"button_wrapper-2OZPZ","resend":"resend-106mk"};